import React from 'react';

export const DEFAULT_BROWSER_TITLE = 'Kronos';

/** Flatten PageTitle contents (string or React node) into plain text for document.title. */
export const titleTextFromNode = (node) => {
    if (node == null || typeof node === 'boolean') {
        return '';
    }
    if (typeof node === 'string' || typeof node === 'number') {
        return String(node);
    }
    if (Array.isArray(node)) {
        return node.map(titleTextFromNode).join('');
    }
    if (React.isValidElement(node)) {
        return titleTextFromNode(node.props.children);
    }
    return '';
};

export const formatBrowserTitle = (pageTitle, prefix) => {
    const name = titleTextFromNode(pageTitle).trim().replace(/\s+/g, ' ');
    const kind = titleTextFromNode(prefix).trim().replace(/\s+/g, ' ');
    const text = kind && name ? `${kind} | ${name}` : (name || kind);
    return text ? `${text} · ${DEFAULT_BROWSER_TITLE}` : DEFAULT_BROWSER_TITLE;
};

/** Join heading meta bits: original title · year · duration. */
export const join_title_meta = (parts) => (
    (parts || [])
        .map((part) => (part == null ? '' : String(part).trim()))
        .filter(Boolean)
        .join(' · ')
);
